import DimensionClassificationsContainer from './DimensionClassifications.container';
export default DimensionClassificationsContainer;